import { makeStyles } from '@mui/styles';

export const useCustomersRowStyle = makeStyles(() => ({
  cellStyle: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
}));
